import React, { useState } from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container as ContainerBase } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import loginImage from "images/login.svg";
import Swal from 'sweetalert2';
import logo from "images/logo.png";
import { ReactComponent as LoginIcon } from "feather-icons/dist/icons/log-in.svg";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Light from "./headers/light";
import { ReactComponent as EyeIcon } from "feather-icons/dist/icons/eye.svg";
import { ReactComponent as EyeOffIcon } from "feather-icons/dist/icons/eye-off.svg";
import { useTranslation } from 'react-i18next';
import Footerr from "./footers/Footer";

const Container = tw(ContainerBase)`min-h-screen  text-white font-medium flex justify-center -m-8`;
const Content = tw.div`max-w-screen-xl m-0 sm:mx-20 sm:my-16 bg-white text-gray-900 shadow sm:rounded-lg flex justify-center flex-1`;
const MainContainer = tw.div`lg:w-1/2 xl:w-5/12 p-6 sm:p-12`;
const LogoLink = tw.a``;
const LogoImage = tw.img`h-12 mx-auto`;
const MainContent = tw.div`mt-12 flex flex-col items-center`;
const Heading = tw.h1`text-2xl xl:text-3xl font-extrabold`;
const FormContainer = tw.div`w-full flex-1 mt-8`;

const SocialButtonsContainer = tw.div`flex flex-col items-center`;
const SocialButton = styled.a`
  ${tw`w-full max-w-xs font-semibold rounded-lg py-3 border text-gray-900 bg-gray-100 hocus:bg-gray-200 hocus:border-gray-400 flex items-center justify-center transition-all duration-300 focus:outline-none focus:shadow-outline text-sm mt-5 first:mt-0`}
  .iconContainer {
    ${tw`bg-white p-2 rounded-full`}
  }
  .icon {
    ${tw`w-4`}
  }
  .text {
    ${tw`ml-4`}
  }
`;

const DividerTextContainer = tw.div`my-12 border-b text-center relative`;
const DividerText = tw.div`leading-none px-2 inline-block text-sm text-gray-600 tracking-wide font-medium bg-white transform -translate-y-1/2 absolute inset-x-0 top-1/2 bg-transparent`;

const Form = tw.form`mx-auto max-w-xs`;
const Input = styled.input`
  ${tw`w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white mt-5 first:mt-0`}
  ${props => props.hasError && tw`border-red-500`}
`;
const ErrorMessage = tw.p`text-red-500 text-xs mt-1`;

const SubmitButton = styled.button`
  ${tw`mt-5 tracking-wide font-semibold bg-[#707070] text-gray-100 w-full py-4 rounded-lg transition-all duration-300 ease-in-out flex items-center justify-center`}
  
  &:hover {
    background-color: #4e7662; /* Change to #4e7662 when hovered */
  }
  
  .icon {
    ${tw`w-6 h-6 -ml-2`}
  }
  
  .text {
    ${tw`ml-3`}
  }
`;


const IllustrationContainer = tw.div`sm:rounded-r-lg flex-1 text-center hidden lg:flex justify-center`;
const IllustrationImage = styled.div`
  ${props => `background-image: url("${props.imageSrc}");`}
  ${tw`m-12 xl:m-16 w-full max-w-lg bg-contain bg-center bg-no-repeat`}
`;

const Login = ({
  logoLinkUrl = "#",
  illustrationImageSrc = loginImage,
  // headingText = t('Se_connecter'),
  // submitButtonText = "Se connecter",
  SubmitButtonIcon = LoginIcon,
  signInUrl = "signup",
  forgotPasswordUrl = "/forgot-password"
}) => {
      const { t } = useTranslation();

  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setFieldErrors({});
    setLoading(true);

    try {
      const response = await axios.post(
        "  https://rehabwmg.online/api/login", // Ensure you're using HTTPS for security
        { identifier, password },
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (response.status === 200 || response.status === 201) {
        const { token, user } = response.data;
        
        // Store token securely (consider httpOnly cookies for better security)
        localStorage.setItem('authToken', token);
        localStorage.setItem('id', user.id);
        localStorage.setItem('isAdmin', user.is_admin); 
        localStorage.setItem('isActive', user.is_active); 
        localStorage.setItem('role', user.role); // Store admin status
        localStorage.setItem('admin_type', user.admin_type); // Store admin status

        localStorage.setItem('user', JSON.stringify(user));
        if (user.is_admin) {
          navigate('/dashbord-admin');
      }else{
        navigate('/');
    }

      }

    } catch (error) {
      if (error.response) {
        const serverError = error.response.data;
    
        // Check if the error message contains account deletion
        if (serverError.error === 'Your account has been deleted.') {
       Swal.fire('Erreur!', 'Votre compte a été supprimé.', 'error');
            localStorage.clear();
        } else {
          // Fallback for invalid credentials or other errors
          setError("L identifiant ou le mot de passe est incorrect." || "Une erreur inconnue s'est produite. Veuillez réessayer.");
        }
    
        // Check if there are validation errors and set them
        if (serverError.errors) {
          setFieldErrors(serverError.errors);
        }
      } else {
        // Handle network errors or server connection issues
        setError("Impossible de se connecter. Veuillez vérifier votre connexion.");
      }
    }  finally {
      setLoading(false);
    }
  };

  return (
    <AnimationRevealPage>
      <Light />
      <br />
      <br />
      <Container>
        <Content>
          <MainContainer>
            <LogoLink href={logoLinkUrl}>
              <LogoImage src={logo} />
            </LogoLink>
                          {error && <p tw="mt-4 text-red-600 text-center">{error}</p>}
            
            <MainContent>
              <Heading>{t('Se_connecter')}</Heading>
              <FormContainer>
              
                {/* <DividerTextContainer>
                  <DividerText>Ou connectez-vous avec votre e-mail ou votre identifiant</DividerText>
                </DividerTextContainer> */}
                <Form onSubmit={handleSubmit}>
                  <Input
                    type="text"
                    id="identifier"
                    name="identifier"
                    required
                    value={identifier}
                    onChange={(e) => setIdentifier(e.target.value)}
                    placeholder={t('Identifiant')}
                    hasError={fieldErrors.identifier}
                  />
                  {fieldErrors.identifier && <ErrorMessage>{fieldErrors.identifier[0]}</ErrorMessage>}
                  <br/>

                  <div style={{ position: "relative" }}>
  <Input
    type={showPassword ? "text" : "password"}
    id="password"
    name="password"
    required
    value={password}
    onChange={(e) => setPassword(e.target.value)}
    placeholder={t('Mot_de_passe')}
    hasError={fieldErrors.password}
  />
  <button
    type="button"
    onClick={togglePasswordVisibility}
    style={{
      position: "absolute",
      right: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      background: "transparent",
      border: "none",
      cursor: "pointer"
    }}
  >
    {showPassword ? <EyeOffIcon width={20} height={20} /> : <EyeIcon width={20} height={20} />}
  </button>
</div>
                  {fieldErrors.password && <ErrorMessage>{fieldErrors.password[0]}</ErrorMessage>}

                  {/* {error && <ErrorMessage>{error}</ErrorMessage>} */}
                  
                  <SubmitButton type="submit" disabled={loading}>
                    {loading ? t('Connexion') : <>
                      {/* <SubmitButtonIcon className="icon" /> */}
                      <span className="text" style={{marginLeft:'10px'}}>{t('Se_connecter')}</span>
                    </>}
                  </SubmitButton>
                </Form>
                <p tw="mt-8 text-sm text-gray-600 text-center">
  {t('Vous_navez_pas_de_compte')}{" "}
                  <a href={signInUrl} tw="border-b border-gray-500 border-dotted">
{t('Inscrivez_vous')}                  </a>
                </p>
                <p tw="mt-6 text-xs text-gray-600 text-center">
                  <a href={forgotPasswordUrl} tw="border-b border-gray-500 border-dotted">
{t('Mot_de_passe_oublié')}                  </a>
                </p>
              </FormContainer>
            </MainContent>
          </MainContainer>
          <IllustrationContainer>
            <IllustrationImage imageSrc={illustrationImageSrc} />
          </IllustrationContainer>
        </Content>
      </Container>
      <Footerr />
    </AnimationRevealPage>
  );
};

export default Login;
